// 至尊麻將王 — Phaser 4 啟動入口
// 對應 PRD §2 src/main.ts、§4.1 場景流轉
//
// 此檔負責：
// 1. 從 game-config 取得 Phaser 設定（解析度、scale 模式、背景色）
// 2. 註冊首頁、底台、擲骰、牌局、三段結算與牌局組總結算場景
// 3. 建立 Phaser.Game 實例，掛到 index.html 的 #app 容器
//
// 注意：Phaser.Game 一旦建立就會自動跑第一個 Scene（Boot），
// 不需要手動呼叫 start()。

import Phaser from 'phaser';
import { buildGameConfig } from '@config/game-config';
import {
  CBootScene,
  CDiceScene,
  CTableSelectScene,
  CGameSetupScene,
  CGameScene,
  CHomeScene,
  CResultTileScene,
  CResultPointScene,
  CResultMoneyScene,
  CSessionSummaryScene,
  CShopScene,
  CRecordsScene,
} from '@scenes/index';
import { installOrientationMask } from '@ui/orientation-mask';
import { installPromptListener } from '@ui/install-hint';
import { showNotice } from '@ui/notice-toast';
import { consumeLoginFragment, LoginResult } from '@net/account-client';

// 先掛上方向遮罩監聽（直式裝置會顯示「請旋轉」覆蓋）
installOrientationMask();
// 盡早攔下 Chrome 的「安裝 App」提示，首頁再用自己的大按鈕觸發
installPromptListener();
// LINE 登入導回：先把網址上的新憑證存起來，之後的 API 才會用登入後的帳號
const loginResult = consumeLoginFragment();
if (loginResult === LoginResult.Success) showNotice('LINE 登入成功');
else if (loginResult === LoginResult.Failed) showNotice('LINE 登入沒有完成，請再試一次');

// Scene 順序＝啟動順序，第一個 Scene（Boot）會自動執行
const config = buildGameConfig([
  CBootScene,
  CHomeScene,
  CTableSelectScene,
  CGameSetupScene,
  CDiceScene,
  CGameScene,
  CResultTileScene,
  CResultPointScene,
  CResultMoneyScene,
  CSessionSummaryScene,
  CShopScene,
  CRecordsScene,
]);

new Phaser.Game(config);
